import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useCancelApplication = (
  isLoading,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isApplicationStatusAllowed =
    [
      'FOR PERMIT PROCESS',
      'FOR LICENSE ASSESSMENT',
      'FOR RESUBMISSION',
      'COMPUTED',
    ].indexOf(applicationStatus) > -1;

  const isAllowed = true && isApplicationStatusAllowed;

  const showComponent = isAllowed;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to cancel this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onHandleClick}
      type="button"
      className="btn btn-danger font-weight-bold"
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Cancel Application
    </button>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useCancelApplication;
